import React, { useState, useCallback, useEffect } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { debounce } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { svgRatifiedBase64 } from "../../Constants/config";
import { useSelector } from "react-redux";
import { useToast } from "../../Utils/toastContext";
import DocumentPreview from "../Create-Investment/documentpreview";
export default function UserQuestionnaire({
  customerName,
  apidata,
  isPending,
  heading,
  eddId,
  afterSubmit,
  isReadOnly,
}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userStatus = useSelector((state) => state.user.userStatus);
  const hasPendingEDD = useSelector((state) => state.user.eddStatus);
  const location = useLocation();

  // const [questions] = useState([
  //   {
  //     id: 1,
  //     question: "What services does your estate agency provide?",
  //     type: { value: 4, label: "Checkbox" },
  //     required: true,
  //     options: [
  //       { value: 1, label: "Acting as a buyer’s agent" },
  //       { value: 2, label: "Acting as a seller’s agent" },
  //       {
  //         value: 3,
  //         label:
  //           "Acting as a leasing agent (long term leases of 30+ years only)",
  //       },
  //       { value: 4, label: "Short term leases or management of property" },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     question:
  //       "In your usual day to day business, what is the legal status of your clients?",
  //     type: { value: 3, label: "Select" },
  //     required: true,
  //     options: [
  //       { value: 1, label: "Individuals" },
  //       { value: 2, label: "Sole Traders" },
  //       { value: 3, label: "Partnerships" },
  //       { value: 4, label: "Trusts (including Family Trusts)" },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     question: "How are your clients conducting business?",
  //     type: { value: 5, label: "Checkbox With Percent" },
  //     required: true,
  //     options: [
  //       { value: 1, label: "Owner/occupier of the property" },
  //       {
  //         value: 2,
  //         label:
  //           "Investment landlord, who might own up to 10 properties in Australia",
  //       },
  //       { value: 3, label: "Small scale professional developer" },
  //       { value: 4, label: "Large corporate developer" },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     question:
  //       "Does your agency typically receive money directly from clients for the purchase or leasing of property?",
  //     type: { value: 2, label: "Radio" },
  //     required: true,
  //     options: [
  //       {
  //         value: 1,
  //         label:
  //           "Yes (including cash or a direct bank transfer to the estate agency)",
  //       },
  //       { value: 2, label: "No (all money transfers handled by conveyancer)" },
  //     ],
  //   },
  //   {
  //     id: 5,
  //     question:
  //       "Please list the countries that your clients are typically from, and a very approximate % for each country. Please include Australia in the list.",
  //     type: { value: 5, label: "Checkbox With Percent" },
  //     required: true,
  //     options: [
  //       { value: 1, label: "Australia" },
  //       { value: 2, label: "USA" },
  //       { value: 3, label: "Afghanistan" },
  //       { value: 4, label: "China" },
  //       { value: 5, label: "India" },
  //       { value: 6, label: "United Kingdom" },
  //       { value: 7, label: "Other" },
  //     ],
  //   },
  //   {
  //     id: 6,
  //     question: "Please provide any additional comments or feedback:",
  //     type: { value: 1, label: "Text" },
  //     required: true,
  //     options: [
  //       { value: 1, label: "Australia" },
  //       { value: 2, label: "USA" },
  //       { value: 3, label: "Afghanistan" },
  //       { value: 4, label: "China" },
  //       { value: 5, label: "India" },
  //       { value: 6, label: "United Kingdom" },
  //       { value: 7, label: "Other" },
  //     ],
  //   },
  // ]);
  const roleName = useSelector((state) => state.user.roleName);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [isHidden, setIsHidden] = useState(false);
  const [preSelectedQuestionType, setPreSelectedQuestionType] = useState({});
  // User answers
  const [answers, setAnswers] = useState({});

  // Handlers
  const handleRadioChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleSelectChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleFileChange = async (e, qId) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    let toastMessage = null;
    const fileType = selectedFile.type;
    const fileSize = selectedFile.size;
    if (
      ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
      fileSize <= 10 * 1024 * 1024
    ) {
      setLoading(true);
      try {
        const response = await fileUploadNew(selectedFile);
        if (response.status == 201) {
          setAnswers((prev) => ({
            ...prev,
            [qId]: {
              ...prev[qId],
              file: {
                file_id: response.data.file_id,
                file_name: response.data.file_name,
              },
            },
          }));
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    } else {
      showToast("File must be PDF, PNG, or JPEG and less than 10MB.", "error");
    }
  };
  const handleDeleteFile = (qId) => {
    setAnswers((prev) => ({
      ...prev,
      [qId]: {
        ...prev[qId],
        file: null,
      },
    }));
  };
  const handlePercentBlur = (questionId, optionId, value) => {
    let numberValue = parseFloat(value);

    if (isNaN(numberValue)) numberValue = 0;

    // Keep the numeric value in state
    handleCheckboxWithPercentChange(
      questionId,
      optionId,
      "percent",
      numberValue,
    );
  };

  const handlePercentChange = (questionId, optionId, value) => {
    const numericValue = value === "" ? "" : parseFloat(value);
    handleCheckboxWithPercentChange(
      questionId,
      optionId,
      "percent",
      numericValue,
    );
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleCheckboxChange = (questionId, optionIndex) => {
    const prev = answers[questionId] || [];
    const exists = prev.includes(optionIndex);
    const updated = exists
      ? prev.filter((i) => i !== optionIndex)
      : [...prev, optionIndex];
    setAnswers({ ...answers, [questionId]: updated });
  };

  const handleCheckboxWithPercentChange = (
    questionId,
    optionId,
    field,
    value,
  ) => {
    setAnswers((prev) => {
      const prevList = prev[questionId] || [];

      const existingIndex = prevList.findIndex((x) => x.id === optionId);

      let updatedList;

      if (existingIndex === -1) {
        updatedList = [
          ...prevList,
          {
            id: optionId,
            checked: field === "checked" ? value : false,
            percent: field === "percent" ? value : "",
          },
        ];
      } else {
        updatedList = prevList.map((item, idx) => {
          if (idx !== existingIndex) return item;

          const updated = { ...item };

          if (field === "checked") {
            updated.checked = value;

            if (!value) updated.percent = "";
          }

          if (field === "percent") {
            updated.percent = value;
            updated.checked = value !== "" ? true : updated.checked;
          }

          return updated;
        });
      }

      return {
        ...prev,
        [questionId]: updatedList,
      };
    });
  };
  const formatAnswersPayload = (answers) => {
    return {
      answers: Object.keys(answers).map((qId) => {
        const value = answers[qId];

        let formattedValue;

        // 1. Array of strings
        if (Array.isArray(value) && typeof value[0] === "string") {
          formattedValue = value;
        }

        // 2. Object (dropdown / single select)
        else if (value && typeof value === "object" && !Array.isArray(value)) {
          // File case
          if (value.file) {
            formattedValue = {
              file_id: value.file.file_id,
              file_name: value.file.file_name,
            };
          } else {
            formattedValue = {
              id: value.id,
              label: value.label,
            };
          }
        }

        // 3. Array of objects (checkbox with percent)
        else if (Array.isArray(value) && typeof value[0] === "object") {
          formattedValue = value
            .filter((item) => item.checked)
            .map((item) => ({
              id: item.id,
              percent: item.percent,
            }));
        }

        // 4. Simple string
        else {
          formattedValue = value;
        }

        return {
          question_id: Number(qId),
          value: formattedValue,
        };
      }),
    };
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let c = answers;
    let x = eddId;
    let apiUrl = `${BASE_URL}/api/v1/customer/edd/${eddId}`;
    let bodyData = formatAnswersPayload(answers);
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: "success" };
        afterSubmit();
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const downloadPDF = useCallback(
    debounce((e) => {
      setIsHidden(true);
    }, 1000), // Debounce time
    [], // Dependencies
  );
  const handleContinue = () => {
    setLoading(true);
    downloadPDF();
  };
  const mapQuestionType = (typeName) => {
    switch (typeName?.toLowerCase()) {
      case "text":
        return 1;
      case "radio":
        return 2;
      case "select":
        return 3;
      case "checkbox":
        return 4;
      case "checkbox_with_percent":
      case "checkboxwithpercent":
        return 5;
      default:
        return 1;
    }
  };
  const validateAnswers = () => {
    for (let q of questions) {
      if (q.required) {
        const answer = answers[q.id];

        // TEXT
        if (
          q.type.value === 1 &&
          (!answer || answer.toString().trim() === "")
        ) {
          showToast(`Please answer: "${q.question}"`, "error");
          return false;
        }

        // RADIO
        if (q.type.value === 2 && !answer) {
          showToast(`Please select an option for: "${q.question}"`, "error");
          return false;
        }

        // SELECT
        if (q.type.value === 3 && (!answer || !answer.id)) {
          showToast(`Please select a value for: "${q.question}"`, "error");
          return false;
        }

        // CHECKBOX
        if (q.type.value === 5 && (!answer || answer.length === 0)) {
          showToast(
            `Please select at least one option for: "${q.question}"`,
            "error",
          );
          return false;
        }

        // CHECKBOX WITH PERCENT
        if (q.type.value === 4) {
          if (
            !answer ||
            !Array.isArray(answer) ||
            answer.filter((item) => item.checked).length === 0
          ) {
            showToast(
              `Please select at least one option for: "${q.question}"`,
              "error",
            );
            return false;
          }

          const invalidPercent = answer.some(
            (item) =>
              item.checked &&
              (item.percent === undefined || item.percent === ""),
          );
          if (invalidPercent) {
            showToast(
              `Please enter percent values for all selected options in: "${q.question}"`,
              "error",
            );
            return false;
          }
        }

        // FILE
        if (q.type.value === 8 && (!answer || !answer.file)) {
          showToast(`Please upload a file for: "${q.question}"`, "error");
          return false;
        }
      }
    }
    return true;
  };

  const formatLabel = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);
  // const questionsHtml = questions
  //   .map((q) => {
  //     let optionsHtml = "";

  //     // TEXT
  //     if (q.type?.value === 1) {
  //       optionsHtml = `
  //       <div class="answer-box font-medium">
  //         ${answers[q.id] || ""}
  //       </div>
  //     `;
  //     }

  //     // RADIO
  //     if (q.type?.value === 2) {
  //       optionsHtml = q.options
  //         .map(
  //           (opt) => `
  //       <div class="option">
  //         <span class="circle ${answers[q.id] === opt ? "checked" : ""}"></span>
  //         <span>${opt.label}</span>
  //       </div>
  //     `,
  //         )
  //         .join("");
  //     }

  //     // SELECT
  //     if (q.type?.value === 3) {
  //       optionsHtml = `
  //       <div class="answer-box">
  //         ${answers[q.id]?.label || ""}
  //       </div>
  //     `;
  //     }

  //     // CHECKBOX
  //     if (q.type?.value === 4) {
  //       optionsHtml = q.options
  //         .map(
  //           (opt, i) => `
  //       <div class="option">
  //         <span class="checkbox  ${
  //           (answers[q.id] || []).includes(i) ? "checked" : ""
  //         }"></span>
  //         <span>${opt.label}</span>
  //       </div>
  //     `,
  //         )
  //         .join("");
  //     }

  //     // CHECKBOX WITH PERCENT
  //     if (q.type?.value === 5) {
  //       optionsHtml = q.options
  //         .map((opt, i) => {
  //           const userOpt =
  //             (answers[q.id] || []).find((a) => a.id === opt.id) || {};
  //           return `
  //         <div class="option percent-row">
  //           <span class="checkbox ${userOpt.checked ? "checked" : ""}"></span>
  //           <span class="percent-label font-medium">${opt.label}</span>
  //           <span class="percent-value font-medium">${
  //             userOpt.checked ? userOpt.percent + "%" : ""
  //           }</span>
  //         </div>
  //       `;
  //         })
  //         .join("");
  //     }

  //     return `
  //     <div class="question-card">
  //       <div class="question name-label font-medium">${q.id}. ${q.question}</div>
  //       <div class="options font-medium">
  //         ${optionsHtml}
  //       </div>
  //     </div>
  //   `;
  //   })
  //   .join("");
  const questionsHtml = apidata
    ?.map((group) => {
      const groupHeader = `
      <div style="margin-bottom:12px; display:flex; justify-content:space-between; align-items:center;">
        <div style="font-size:12px;">
          <span class="name-label font-medium">Requested By:</span> ${group.requestedBy || "-"}
        </div>
        <div style="font-size:10px; color:#666;">
          ${group.respondedAt || ""}
        </div>
      </div>
    `;

      const questionsBlock = group.questions
        ?.map((q) => {
          let optionsHtml = "";

          // ✅ TEXT
          if (q.type.value === 1) {
            optionsHtml = `
            <div class="answer-box">${q.answer?.value || ""}</div>
          `;
          }

          // ✅ RADIO
          if (q.type.value === 2) {
            optionsHtml = (q.options || [])
              .map(
                (opt) => `
              <div class="option">
                <span class="circle ${
                  q.answer?.value === opt.value ? "checked" : ""
                }"></span>
                <span>${opt.label}</span>
              </div>
            `,
              )
              .join("");
          }

          // ✅ SELECT
          if (q.type.value === 3) {
            optionsHtml = `
            <div class="answer-box">
              ${q.answer?.value?.value || ""}
            </div>
          `;
          }

          // ✅ CHECKBOX
          if (q.type.value === 5 || q.type.value === 6) {
            optionsHtml = (q.options || [])
              .map(
                (opt) => `
              <div class="option">
                <span class="checkbox ${
                  (q.answer?.value || []).includes(opt.value) ? "checked" : ""
                }"></span>
                <span>${opt.label}</span>
              </div>
            `,
              )
              .join("");
          }

          // ✅ CHECKBOX WITH PERCENT
          if (q.type.value === 4) {
            optionsHtml = (q.options || [])
              .map((opt) => {
                const userOpt =
                  (q.answer?.value || []).find((a) => a.id === opt.id) || {};

                return `
                <div class="option percent-row">
                  <span class="checkbox ${userOpt.id ? "checked" : ""}"></span>
                  <span class="percent-label">${opt.label}</span>
                  <span class="percent-value">
                    ${userOpt.percent ? userOpt.percent + "%" : ""}
                  </span>
                </div>
              `;
              })
              .join("");
          }

          // ✅ FILE
          if (q.type.value === 8 && q.answer?.file) {
            optionsHtml = `
            <div class="answer-box">
              ${q.answer.file.file_name}
            </div>
          `;
          }

          return `
          <div class="question-card">
            <div class="question">
              ${q.id}. ${q.question}
            </div>
            <div class="options">
              ${optionsHtml}
            </div>
          </div>
        `;
        })
        .join("");

      return `
      <div style="margin-bottom:25px;">
        ${groupHeader}
        ${questionsBlock}
      </div>
    `;
    })
    .join("");
  const handleDownloadPDF = async () => {
    const fullHtml = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>

<style>

@page{
  size:A4;
  margin:30px;
}

body{
  font-family:sans-serif;
  margin:0;
  padding:0;
  background:#ffffff;
}

.header{
  border-bottom:2px solid #eee;
  padding-bottom:12px;
  margin-bottom:25px;
}
.font-medium{
  font-weight:500;
}
/* Center logo */
.logo-row{
  text-align:center;
  margin-bottom:10px;
}

.logo{
  height:40px;
  width:auto;
}

/* Customer + Date row */
.info-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.title{
  font-size:14px;
}

.date{
  font-size:10px;
  color:#666;
}

.question-card{
  border:1px solid #e5e7eb;
  border-radius:8px;
  padding:16px;
  margin-bottom:18px;
  page-break-inside:avoid;
}

.question{
  font-size:12px;
  margin-bottom:10px;
}
  .name-label{
  color:#666}

.options{
  margin-left:5px;
}

.option{
  display:flex;
  align-items:center;
  gap:10px;
  margin-bottom:6px;
  font-size:11px;
}

.circle{
  width:12px;
  height:12px;
  border-radius:50%;
    background: #444;
}

.circle.checked{
  background:#375AE7;
  border-color:#375AE7;
}

.checkbox {
  width: 14px;
  height: 14px;
    background: #444;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  display: inline-block;
}

.checkbox.checked{
  background:#375AE7;
  border-color:#375AE7;
}
  .checkbox.checked::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
    border-radius: 2px;

  transform: rotate(45deg);
}


.answer-box{
  border:1px solid #ddd;
  padding:8px 10px;
  border-radius:4px;
  font-size:11px;
}

.percent-row{
  justify-content:space-between;
}

.percent-label{
  flex:1;
}

.percent-value{
  width:60px;
  text-align:right;
  font-weight:500;
}

.footer{
  margin-top:40px;
  text-align:center;
  font-size:10px;
  color:#777;
}

</style>
</head>

<body>

<div class="header">
  
  <!-- Logo Row -->
  <div class="logo-row">
    <img src="${svgRatifiedBase64}" alt="Logo" class="logo" />
  </div>

  <!-- Info Row -->
  <div class="info-row">
    <div class="title"><span class="name-label">Customer Name: </span>${customerName}</div>
    <div class="date">${new Date().toLocaleDateString()}</div>
  </div>

</div>

${questionsHtml}

<div class="footer">
Generated by Ratified System
</div>

</body>
</html>
`;

    //const token = localStorage.getItem("jwtToken");
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo1OTQsInJvbGUiOiJjdXN0b21lciIsInByZXZpb3VzX3VzZXJfaWQiOm51bGwsImNsaWVudF9pZCI6IkNNMDAyMzM0OFAiLCJleHAiOjE3NzYwODYyNjV9.JCXgyJbU8OonMEHZXcGN-PRs8UUUrsFB-BD9Ng-k01M";
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `https://demoapi.pwa.caprock.com.au/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      },
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Risk-Assessment-Questionnaire.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  useEffect(() => {
    if (isPending) {
      // ✅ Pending → normal flat questions
      setQuestions(apidata || []);
    } else {
      // ❌ Completed → don't flatten
      setQuestions([]); // handled separately in UI
    }
  }, [apidata, isPending]);
  // useEffect(() => {
  //   if (!isPending) {
  //     if (!questions || questions.length === 0) return;

  //     const formatted = {};

  //     questions.forEach((q) => {
  //       const ans = q.answer?.value;

  //       if (!ans) return;

  //       // TEXT / RADIO
  //       if (q.type.value === 1 || q.type.value === 2) {
  //         formatted[q.id] = ans;
  //       }

  //       // SELECT
  //       else if (q.type.value === 3) {
  //         formatted[q.id] = { id: ans.id, label: ans.value }; // already {id, label}
  //       }

  //       // CHECKBOX / MULTI SELECT
  //       else if (q.type.value === 5 || q.type.value === 6) {
  //         formatted[q.id] = ans; // array of strings
  //       }

  //       // CHECKBOX WITH PERCENT
  //       else if (q.type.value === 4) {
  //         formatted[q.id] = ans.map((item) => ({
  //           id: item.id,
  //           checked: true,
  //           percent: item.percent,
  //         }));
  //       }

  //       // FILE
  //       else if (q.type.value === 8) {
  //         formatted[q.id] = {
  //           file: {
  //             file_id: q.answer.file.file_id,
  //             file_name: q.answer.file.file_name,
  //             s3_path: q.answer.file.s3_path,
  //             presigned_url: q.answer.file.presigned_url,
  //           },
  //         };
  //       }
  //     });

  //     setAnswers(formatted);
  //   }
  // }, [questions, isPending]);
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);

  return (
    <div className=" p-3">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
        {/* Heading */}
        <h1 className="text-xl font-medium flex items-center gap-2">
          {heading}
          <span
            className={`material-symbols-outlined text-lg ${
              isPending ? "text-yellow-500" : "text-green-600"
            }`}
          >
            {isPending ? "schedule" : "check_circle"}
          </span>
          <span
            className={`text-sm font-medium ${
              isPending ? "text-yellow-600" : "text-green-600"
            }`}
          >
            ({isPending ? "Pending" : "Completed"})
          </span>
        </h1>

        {/* Download Button */}
        {!isPending && !isReadOnly && (
          <button
            //   disabled={!areAllQuestionsAnswered}
            onClick={handleContinue}
            className={`mt-3 sm:mt-0 flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition bg-[#375AE7] text-white hover:bg-[#2f4bd3]
 
  `}
          >
            <span className="material-symbols-outlined text-lg">download</span>
            Download PDF
          </button>
        )}
      </div>
      {roleName === "customer" && isPending && (
        <div className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm space-y-5 text-sm">
          {/* Header */}
          <div className="flex items-start gap-3">
            <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">🛡️</div>
            <div>
              <h3 className="text-base font-semibold text-gray-900">
                Why we may ask for extra information
              </h3>
              <p className="text-gray-500 text-xs mt-1">
                To keep your account secure and meet legal requirements
              </p>
            </div>
          </div>

          {/* Reasons */}
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4">
            <ul className="space-y-2 text-gray-700">
              <li>• To confirm your identity if standard checks don’t work</li>
              <li>• If your name or details don’t fully match</li>
              <li>• If you're linked to a higher-risk country or situation</li>
              <li>• If ownership or transactions are unclear or complex</li>
            </ul>
          </div>

          {/* What we ask */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded-md text-xs font-semibold">
                What we may ask for
              </span>
            </div>
            <div className="bg-purple-50 border border-purple-100 rounded-xl p-4">
              <ul className="space-y-2 text-gray-700">
                <li>• Extra ID or verification documents</li>
                <li>• Details about where your money comes from</li>
              </ul>
            </div>
          </div>

          {/* What happens next */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="bg-green-100 text-green-600 px-2 py-1 rounded-md text-xs font-semibold">
                What happens next
              </span>
            </div>
            <div className="bg-green-50 border border-green-100 rounded-xl p-4">
              <ul className="space-y-2 text-gray-700">
                <li>• We review your information securely</li>
                <li>• This helps keep your account safe and compliant</li>
              </ul>
            </div>
          </div>
        </div>
      )}
      <form>
        {isPending && (
          <>
            {questions.map((q) => (
              <div
                key={q.id}
                className="text-sm mb-6 p-4 bg-white rounded-lg shadow-sm"
              >
                <p className="text-labelColour mb-3">{q.question}</p>
                {/* Text Input */}
                {q.type?.value === 1 && (
                  <input
                    type="text"
                    value={answers[q.id] || ""}
                    onChange={(e) =>
                      setAnswers({ ...answers, [q.id]: e.target.value })
                    }
                    disabled={roleName == "agent" || !isPending}
                    className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Type your answer here"
                  />
                )}
                {/* Radio */}
                {q.type?.value === 2 &&
                  q.options.map((opt, i) => (
                    <label
                      key={i}
                      className="flex items-center gap-2 mb-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name={`q-${q.id}`}
                        checked={answers[q.id] === opt.value}
                        disabled={roleName == "agent" || !isPending}
                        onChange={() => handleRadioChange(q.id, opt.value)}
                        className="confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]"
                      />
                      <span>{opt.label}</span>
                    </label>
                  ))}

                {/* Select */}
                {q.type?.value === 3 && (
                  <Dropdown
                    label=""
                    options={q.options}
                    onSelect={(value) => handleSelectChange(q.id, value)}
                    preselectedValue={answers[q.id]}
                    disabled={roleName == "agent" || !isPending}
                  />
                )}

                {/* Checkbox */}
                {(q.type?.value === 5 || q.type?.value === 6) &&
                  (q.options || []).map((opt, i) => (
                    <label
                      key={i}
                      className="flex items-center gap-2 mb-2 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={(answers[q.id] || []).includes(opt.value)}
                        disabled={roleName == "agent" || !isPending}
                        onChange={() => handleCheckboxChange(q.id, opt.value)}
                        className={`${roleName == "agent" || !isPending ? "border-2 border-[#FF5050] checked:border-gray-500 checked:bg-gray-500" : "border-2 border-[#375AE7] checked:border-[#375AE7] checked:bg-[#375AE7] custom-checkbox "} rounded h-4 w-4 relative`}
                      />
                      <span>{opt.label}</span>
                    </label>
                  ))}

                {/* Checkbox With Percent */}
                {q.type?.value === 4 &&
                  q.options.map((opt, i) => {
                    const userOpt =
                      (answers[q.id] || []).find((a) => a.id === opt.id) || {};

                    return (
                      <div
                        key={opt.id}
                        className="flex items-center gap-3 mb-2"
                      >
                           <input
                      type="checkbox"
                      id={`checkbox-${q.id}-${opt.id}`}
                      disabled={roleName == "agent" || !isPending}
                      checked={userOpt?.checked || false}
                      onChange={(e) =>
                        handleCheckboxWithPercentChange(
                          q.id,
                          opt.id,
                          "checked",
                          e.target.checked,
                        )
                      }
                      className="border-2 border-[#FF5050] accent-[#375AE7] rounded h-4 w-4 cursor-pointer"
                    />

                    <label
                      htmlFor={`checkbox-${q.id}-${opt.id}`}
                      className="flex-1 cursor-pointer"
                    >
                      {opt.label}
                    </label>

                        <div className="relative w-24">
                          <input
                            type="text"
                            placeholder="10.00"
                            value={userOpt.percent ?? ""}
                            disabled={
                              !userOpt.checked ||
                              roleName == "agent" ||
                              !isPending
                            }
                            onChange={(e) => {
                              const value = e.target.value;

                              if (/^\d*\.?\d*$/.test(value)) {
                                handleCheckboxWithPercentChange(
                                  q.id,
                                  opt.id,
                                  "percent",
                                  value,
                                );
                              }
                            }}
                            onBlur={(e) => {
                              const raw = e.target.value;

                              if (raw === "" || raw === ".") {
                                handleCheckboxWithPercentChange(
                                  q.id,
                                  opt.id,
                                  "percent",
                                  "",
                                );
                                return;
                              }

                              const formatted = parseFloat(raw).toFixed(2);

                              handleCheckboxWithPercentChange(
                                q.id,
                                opt.id,
                                "percent",
                                formatted,
                              );
                            }}
                            className={`w-full pr-5 border rounded px-2 py-1 text-right ${
                              !userOpt.checked ? "bg-gray-100" : ""
                            }`}
                          />

                          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500">
                            %
                          </span>
                        </div>
                      </div>
                    );
                  })}
                {q.type?.value === 8 && (
                  <>
                    {/* AGENT VIEW */}
                    {roleName === "agent" &&
                      answers[q.id]?.file &&
                      answers[q.id]?.file.file_name && (
                        <div
                          onClick={() => handleFileClick(answers[q.id].file)}
                          className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2 hover:bg-gray-50"
                        >
                          <span className="text-black underline break-all">
                            {answers[q.id].file.file_name}
                          </span>
                        </div>
                      )}

                    {roleName === "customer" &&
                      answers[q.id]?.file &&
                      !isPending && (
                        <div
                          onClick={() => handleFileClick(answers[q.id].file)}
                          className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2 hover:bg-gray-50"
                        >
                          <span className="text-black underline break-all">
                            {answers[q.id].file.file_name}
                          </span>
                        </div>
                      )}

                    {/* CUSTOMER UPLOAD */}
                    {roleName === "customer" && isPending && (
                      <>
                        {/* Upload Box */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            accept=".pdf,.png,.jpeg"
                            onChange={(e) => handleFileChange(e, q.id)}
                            className="hidden"
                          />

                          <img src="/folder-add.svg" className="h-5 w-5" />

                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>

                        {/* File Types */}
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>

                        {/* Uploaded File */}
                        {answers[q.id]?.file && (
                          <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                            <div
                              onClick={() =>
                                handleFileClick(answers[q.id].file)
                              }
                              className="flex flex-col cursor-pointer"
                            >
                              <span className="text-black underline break-all">
                                {answers[q.id].file.file_name}
                              </span>
                              <span className="text-green-500 text-xs">
                                Upload Completed
                              </span>
                            </div>

                            <button
                              onClick={() => handleDeleteFile(q.id)}
                              className="text-red-500"
                            >
                              <img src="/trash.svg" className="h-4 w-4" />
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            ))}
          </>
        )}
        {!isPending &&
          apidata.map((group) => (
            <div key={group.id} className="mb-6">
              {/* Header */}
              <div className="flex justify-between items-center mb-3">
                <h2 className="text-sm font-semibold text-gray-700">
                  <span className="font-medium"> Requested By:</span>{" "}
                  {group.requestedBy}
                </h2>
                <span className="text-xs text-gray-500">
                  {group.respondedAt}
                </span>
              </div>

              {/* Questions */}
              {group.questions.map((q) => (
                <div
                  key={q.id}
                  className="text-sm mb-4 p-4 bg-white rounded-lg shadow-sm"
                >
                  <p className="text-labelColour mb-2">{q.question}</p>

                  {/* TEXT */}
                  {q.type.value === 1 && (
                    <div className="text-gray-700">{q.answer?.value}</div>
                  )}

                  {/* RADIO */}
                  {q.type.value === 2 &&
                    q.options.map((opt, i) => (
                      <label
                        key={i}
                        className="flex items-center gap-2 mb-2 cursor-pointer"
                      >
                        <input
                          type="radio"
                          name={`q-${q.id}`}
                          checked={q.answer?.value === opt.value}
                          disabled={roleName == "agent" || !isPending}
                          className="confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]"
                        />
                        <span>{opt.label}</span>
                      </label>
                    ))}

                  {/* SELECT */}
                  {q.type.value === 3 && (
                    <div className="text-gray-700">
                      {q.answer?.value?.value}
                    </div>
                  )}

                  {/* CHECKBOX */}
                  {(q.type?.value === 5 || q.type?.value === 6) &&
                    (q.options || []).map((opt, i) => (
                      <label
                        key={i}
                        className="flex items-center gap-2 mb-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={(q.answer?.value || []).includes(opt.value)}
                          disabled={roleName == "agent" || !isPending}
                          className={`${roleName == "agent" || !isPending ? "border-2 border-[#FF5050] checked:border-gray-500 checked:bg-gray-500" : "border-2 border-[#375AE7] checked:border-[#375AE7] checked:bg-[#375AE7] custom-checkbox "} rounded h-4 w-4 relative`}
                        />
                        <span>{opt.label}</span>
                      </label>
                    ))}
                  {q.type?.value === 4 &&
                    q.options.map((opt, i) => {
                      const userOpt =
                        (q.answer?.value || []).find((a) => a.id === opt.id) ||
                        {};

                      return (
                        <div
                          key={opt.id}
                          className="flex items-center gap-3 mb-2"
                        >
                          <input
                            type="checkbox"
                            disabled={roleName == "agent" || !isPending}
                            checked={userOpt || false}
                            className="border-2 border-[#FF5050] rounded h-4 w-4"
                          />

                          <span className="flex-1">{opt.label}</span>

                          <div className="relative w-24">
                            <input
                              type="text"
                              placeholder="10.00"
                              value={userOpt.percent ?? ""}
                              disabled={
                                !userOpt.checked ||
                                roleName == "agent" ||
                                !isPending
                              }
                              onChange={(e) => {
                                const value = e.target.value;

                                if (/^\d*\.?\d*$/.test(value)) {
                                  handleCheckboxWithPercentChange(
                                    q.id,
                                    opt.id,
                                    "percent",
                                    value,
                                  );
                                }
                              }}
                              onBlur={(e) => {
                                const raw = e.target.value;

                                if (raw === "" || raw === ".") {
                                  handleCheckboxWithPercentChange(
                                    q.id,
                                    opt.id,
                                    "percent",
                                    "",
                                  );
                                  return;
                                }

                                const formatted = parseFloat(raw).toFixed(2);

                                handleCheckboxWithPercentChange(
                                  q.id,
                                  opt.id,
                                  "percent",
                                  formatted,
                                );
                              }}
                              className={`w-full pr-5 border rounded px-2 py-1 text-right ${
                                !userOpt.checked ? "bg-gray-100" : ""
                              }`}
                            />

                            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500">
                              %
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  {/* FILE */}
                  {q.type.value === 8 && q.answer?.file && (
                    <div
                      onClick={() => {
                        if (!isReadOnly) {
                          handleFileClick(q.answer.file);
                        }
                      }}
                      className={`${isReadOnly ? "cursor-not-allowed" : "cursor-pointer"} mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2 hover:bg-gray-50`}
                    >
                      <span className="text-black underline break-all">
                        {q.answer.file.file_name}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
      </form>
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {roleName === "customer" && isPending && (
        <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!validateAnswers()) return; // stop submission if validation fails
                setLoading(true);
                handleSubmit();
              }}
              className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Submit</span>
            </button>
          </div>
        </footer>
      )}
      {roleName === "customer" && !hasPendingEDD && userStatus !== "active" && (
        <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            <button
              onClick={(e) => {
                e.preventDefault();
                navigate("/onboarding");
              }}
              className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Back to your application</span>
            </button>
          </div>
        </footer>
      )}
      {roleName === "customer" && !hasPendingEDD && userStatus == "active" && (
        <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 md:space-x-4 relative">
            <button
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
              className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Back to your dashboard</span>
            </button>
          </div>
        </footer>
      )}
    </div>
  );
}